import { PathsEnum } from 'pages/Paths'

export interface ClaimsPathOptions {
  batchId?: string | null
}

/**
 * Returns the base claims path with tntId
 * @param tntId - The tntId (integer) to include in the URL
 * @returns Path in format /:tntId/claims
 */
export const getClaimsPath = (tntId: string | number): string => {
  return `/${tntId}/claims`
}

/**
 * Returns the claim detail path with tntId
 * @param tntId - The tntId (integer) to include in the URL
 * @param oaiClaimId - The claim ID
 * @returns Path in format /:tntId/claims/claim/:oaiClaimId
 */
export const getClaimDetailPath = (tntId: string | number, oaiClaimId: string): string => {
  return `/${tntId}/claims/${PathsEnum.claim}/${oaiClaimId}`
}

/**
 * Returns the claim call path with tntId
 * @param tntId - The tntId (integer) to include in the URL
 * @param oaiClaimId - The claim ID
 * @param callId - The call ID
 * @returns Path in format /:tntId/claims/claim/:oaiClaimId/calls/:callId
 */
export const getClaimCallPath = (tntId: string | number, oaiClaimId: string, callId: string): string => {
  return `/${tntId}/claims/${PathsEnum.claim}/${oaiClaimId}/${PathsEnum.call}/${callId}`
}

/**
 * Returns the claim call summary path with tntId
 * @param tntId - The tntId (integer) to include in the URL
 * @param oaiClaimId - The claim ID
 * @param callId - The call ID
 * @returns Path in format /:tntId/claims/claim/:oaiClaimId/calls-summary/:callId
 */
export const getClaimCallSummaryPath = (tntId: string | number, oaiClaimId: string, callId: string): string => {
  return `/${tntId}/claims/${PathsEnum.claim}/${oaiClaimId}/${PathsEnum.callsSummary}/${callId}`
}
